import React from "react";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateGroup } from "../hooks";
import { GroupForm } from "../components";

export const CreateGroup: React.FC = () => {
  const { form, submit, loading } = useCreateGroup({
    defaultValues: {},
    onCompleted: () => {
      toast.success("Le groupe a été créé avec succès");
    },
  });

  return (
    <>
      <Header
        title="Groupe"
        subtitle="Créer un nouveau groupe"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/groups`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouveau groupe" />
          <GroupForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
